import AppLayout from "../AppLayout";
import { RowDataProvider } from "../contexts/RowDataContext";
import SetupRenderer from "../pages/LandingPage/components/setup/SetupRenderer";
import LandingPage from "../pages/LandingPage/LandingPage";

const HomeRoute = (): JSX.Element => {
  return (
    <RowDataProvider>
      <AppLayout>
        <SetupRenderer>
          <LandingPage />
        </SetupRenderer>
      </AppLayout>
    </RowDataProvider>
  );
};

export default HomeRoute;
